import Config from './container';
import PageLayout from '../../hocs/PageLayout';
import UserRoleAccess from '../../hocs/UserRoleAccess';
export const configRoutes = [
  {
    path: '/config/rest-config',
    component: PageLayout(UserRoleAccess(Config,['mr_calculator', 'dashboard','R']), {apps: 'MRCalculator', layoutPhase: 2}),
    key: 'config'
  },
]
